import {StyleSheet} from 'aphrodite';

import {GRAY_LIGHT} from 'ui-library/Colors';

export const chemSearchModalStyles = StyleSheet.create({
  chemicalDrawer: {
    flex: 1,
    display: 'flex',
    minHeight: 500,
    paddingBottom: 12,
  },
  searchOptions: {
    paddingTop: 12,
    borderTop: `1px solid ${GRAY_LIGHT}`,
  },
  searchOptionsContainer: {
    padding: '0 16px 16px',
  },
});
